import { createStyles, Fade, makeStyles, Theme } from '@material-ui/core';
import Modal from '@material-ui/core/Modal';

import React from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: 'absolute',
    },
    modal: {
      display: 'flex',
      padding: theme.spacing(1),
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      position: 'absolute',
    },
  })
);

interface Props {
  children: any;
  onClose: any;
  open: boolean;
  container: any;
}

export const ModalAlert = ({ children, open, onClose, container }: Props) => {
  const classes = useStyles();
  return (
    <dialog>
      <Modal
        container={() => container.current}
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        disableEnforceFocus
        disableAutoFocus
        open={open}
        onClose={onClose}
        closeAfterTransition
        style={{
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
        }}
        hideBackdrop
      >
        <Fade in={open}>
          <div>{children}</div>
        </Fade>
      </Modal>
    </dialog>
  );
};
